import { useState } from "react";
import { PiBuildingsDuotone } from "react-icons/pi";
import AssetImage from "../../components/AssetImage";
import { assetUrl } from "../../lib/assets";

export default function MerchantBrand({ branding = {}, logoUrl, merchantCode, loading = false, error, onRetry }) {
  const source = logoUrl === undefined
    ? assetUrl(branding.logo_url, { merchantCode }) || assetUrl(branding.website_logo_url, { merchantCode })
    : assetUrl(logoUrl, { merchantCode });
  const [failedSource, setFailedSource] = useState(null);
  const [attempt, setAttempt] = useState(0);
  const retryable = !!onRetry && (!!error || (!!source && failedSource === source));
  const fallback = <PiBuildingsDuotone className="text-primary text-2xl" data-testid="merchant-logo-fallback" aria-hidden="true" />;
  const retry = () => { setFailedSource(null); setAttempt(value => value + 1); onRetry?.(); };
  return (
    <div className="min-h-16 flex items-center gap-3 px-3 lg:px-4 py-3 border-b border-border shrink-0">
      <div aria-busy={loading}
        className="relative w-9 h-9 lg:w-11 lg:h-11 flex items-center justify-center shrink-0 rounded-md bg-transparent">
        {source
          ? <AssetImage key={`${source}-${attempt}`} src={source} merchantCode={merchantCode} alt={`${branding.company_name || "Merchant"} logo`}
              className="w-full h-full object-contain" data-testid="brand-logo" fallback={fallback} onError={() => setFailedSource(source)} />
          : fallback}
        {retryable && <button type="button" onClick={retry} aria-label="Retry sidebar logo"
          title="The sidebar logo could not be refreshed. Click to retry." className="absolute inset-0 rounded-md hover:bg-accent/20">
          <span className="sr-only">Retry sidebar logo</span>
        </button>}
      </div>
      <div className="hidden lg:block leading-none min-w-0 flex-1">
        <div className="font-chivo font-black text-sm tracking-tight truncate text-wrap" data-testid="tenant-brand-name">
          {(branding?.company_name || "").toUpperCase()}
        </div>
        <div className="font-mono text-[9px] tracking-[0.2em] uppercase text-muted-foreground mt-1 truncate">
          {branding?.portal_name || ""}
        </div>
      </div>
    </div>
  );
}
